import React, { MouseEvent } from 'react';
import { css } from 'linaria';
import cn from 'clsx';
import { Typography } from 'common/components';
import { VariantAxisPoint, VariantAxisProduct, VariantsAxis } from 'modules/collections';
import { ExperimentCookie } from 'types/common';
import { AxisPointsA } from './axis-points-a';
import { AxisPointsB } from './axis-points-b';

const axisPointsA = css`
  &&& {
    padding: 24px 0 12px;
  }
`;

const axisPointsB = css`
  padding: 12px 0;
`;

const axisPointName = css`
  && {
    display: flex;
    column-gap: 4px;
    padding-bottom: 8px;
  }
`;

type AxisPointProps = {
  activePoint: VariantAxisProduct;
  axisPoints: VariantAxisPoint[];
  axisMeta: VariantsAxis;
  landingName: string;
  onPointClick: (e: MouseEvent, point: VariantAxisPoint, axis: string) => void;
  experimentCookie: ExperimentCookie;
};

export const AxisPoints: React.FC<AxisPointProps> = ({
  activePoint, axisMeta, axisPoints, landingName, onPointClick, experimentCookie,
}) => {
  const handlePointWheelClick = (e: MouseEvent, point: VariantAxisPoint, axis: string) => () => {
    if (e.button === 1) {
      onPointClick(e, point, axis);
    }
  };

  return (
    <div className={cn({ [axisPointsB]: experimentCookie === 'B' })}>
      <div className={cn(axisPointName, { [axisPointsA]: experimentCookie === 'A' })}>
        <Typography as="span" color="text-secondary" size="body_accent" variant="s">
          {axisMeta.name}:
        </Typography>
        <Typography variant="s" size="body_long" color="text-secondary">
          {activePoint.axesValues?.find(({ id }) => id === axisMeta.attribute)?.axis}
        </Typography>
      </div>

      {experimentCookie === 'A'
        ? (
          <AxisPointsA
            activePoint={activePoint}
            axisMeta={axisMeta}
            axisPoints={axisPoints}
            landingName={landingName}
            onPointClick={onPointClick}
            onPointWheelClick={handlePointWheelClick}
          />
        ) : (
          <AxisPointsB
            activePoint={activePoint}
            axisMeta={axisMeta}
            axisPoints={axisPoints}
            landingName={landingName}
            onPointClick={onPointClick}
            onPointWheelClick={handlePointWheelClick}
          />
        )}
    </div>
  );
};
